import { showValidationErrorsAsToasted } from '@/helpers/ToastedHelper';

export default {
  methods: {
    showErrors(error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        showValidationErrorsAsToasted(
          this.$toasted,
          error.response.data.errors
        );
      } else {
        this.$toasted.error(error.response.data.message, { duration: 3000 });
      }
    },
  },
};
